import React from 'react';
import {VerticalSpacer} from '../../elements';
import {AccentColorOptions} from 'epic-ue-theme';
import {CardCarousel, CardCarouselProps} from '../';

export interface CardCarouselListProps {
    accentColor?: AccentColorOptions;
    carousels?: CardCarouselProps[];
}

export const CardCarouselList = (props: CardCarouselListProps): JSX.Element => {
    const {accentColor = 'sky', carousels = []} = props;

    return (
        <>
            {carousels.map((carousel, i) => {
                return (
                    <React.Fragment key={`carousel-list-${i}`}>
                        <CardCarousel key={i} {...carousel} accentColor={accentColor} />
                        {carousels[i + 1] ? <VerticalSpacer variant="section" /> : ''}
                    </React.Fragment>
                );
            })}
        </>
    );
};
